// Ingredient Page
document.addEventListener('DOMContentLoaded', function() {
  function initializeIngredientBrowser(container) {
    if (container.dataset.ingredientsInitialized === 'true') return;
    container.dataset.ingredientsInitialized = 'true';

    var filters = Array.from(container.querySelectorAll('[data-ingredient-filter]'));
    var cards = Array.from(container.querySelectorAll('.iit-ingredient-box'));
    var ingredientGrid = container.querySelector('.iit-ingredients');
    var ingredientStatus = container.querySelector('[data-ingredient-status]');
    var filterRail = container.querySelector('.iit-tabs-title-container');
    var dialog = container.querySelector('[data-ingredient-dialog]');
    var dialogContent = container.querySelector('[data-ingredient-modal-content]');
    var closeButton = container.querySelector('[data-ingredient-close]');
    var stickyShop = container.querySelector('[data-ingredients-shop-sticky]');
    var expandButton = container.querySelector('[data-ingredient-expand]');
    var supplementFactsCard = container.querySelector('[data-ingredient-supplement-facts-card]');
    var lastTrigger = null;
    var lastVisibleLimit = null;
    var expanded = container.dataset.ingredientExpanded === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ingredientHyphenation = {
      Ashwagandha: 'Ashwa\u00ADgandha',
      Bamboo: 'Bam\u00ADboo',
      Chicory: 'Chic\u00ADory',
      Chondroitin: 'Chon\u00ADdroi\u00ADtin',
      CoEnzyme: 'Co\u00ADEnzyme',
      Collagen: 'Col\u00ADla\u00ADgen',
      Peptides: 'Pep\u00ADtides',
      Postbiotic: 'Post\u00ADbi\u00ADotic',
      Glucosamine: 'Glu\u00ADcos\u00ADamine',
      Porcine: 'Por\u00ADcine',
      Acidophilus: 'Acido\u00ADphilus',
      Pumpkin: 'Pump\u00ADkin',
      Quercetin: 'Quer\u00ADce\u00ADtin',
      Mushroom: 'Mush\u00ADroom',
      Shiitake: 'Shii\u00ADtake',
      Spirulina: 'Spir\u00ADu\u00ADlina',
      Turmeric: 'Tur\u00ADmeric'
    };

    function addIngredientHyphenation(card) {
      if (container.dataset.ingredientHyphenate !== 'true') return;

      var nameElement = card.querySelector('.iit-ingredient-name');
      if (!nameElement) return;

      var name = nameElement.textContent;
      Object.keys(ingredientHyphenation).forEach(function(word) {
        name = name.split(word).join(ingredientHyphenation[word]);
      });
      nameElement.textContent = name;
    }

    cards.forEach(function(card, index) {
      card.dataset.originalIndex = index;
      addIngredientHyphenation(card);
    });

    function getPreviewConfiguration() {
      var isDesktop = window.matchMedia('(min-width: 1100px)').matches;
      var isTablet = !isDesktop && window.matchMedia('(min-width: 750px)').matches;
      var limitAttribute = isDesktop
        ? container.dataset.ingredientVisibleDesktop
        : isTablet
          ? container.dataset.ingredientVisibleTablet
          : container.dataset.ingredientVisibleMobile;
      var rowAttribute = isDesktop
        ? container.dataset.ingredientPreviewRowDesktop
        : isTablet
          ? container.dataset.ingredientPreviewRowTablet
          : container.dataset.ingredientPreviewRowMobile;
      var parsedLimit = Number(limitAttribute);
      var parsedRowSize = Number(rowAttribute || container.dataset.ingredientPreviewRow);

      return {
        columnCount: isDesktop ? 4 : isTablet ? 3 : 2,
        defaultLimit: Number.isFinite(parsedLimit) && parsedLimit > 0
        ? Math.min(parsedLimit, cards.length)
        : cards.length,
        previewRowSize: Number.isFinite(parsedRowSize) && parsedRowSize > 0 ? parsedRowSize : 2
      };
    }

    function getVisibleLimit(priorityCount) {
      if (expanded) return cards.length;

      var previewConfiguration = getPreviewConfiguration();
      var defaultLimit = previewConfiguration.defaultLimit;
      var parsedThreshold = Number(container.dataset.ingredientPreviewThreshold);
      var previewThreshold = Number.isFinite(parsedThreshold) && parsedThreshold >= 0 ? parsedThreshold : 6;
      var previewRowSize = previewConfiguration.previewRowSize;

      if (priorityCount > previewThreshold) {
        var adaptiveLimit = priorityCount + previewRowSize;
        var incompleteRow = adaptiveLimit % previewRowSize;

        if (incompleteRow) adaptiveLimit += previewRowSize - incompleteRow;
        return Math.min(cards.length, Math.max(defaultLimit, adaptiveLimit));
      }

      return Math.min(cards.length, defaultLimit);
    }

    function getPriorityCount(filter) {
      if (!filter || filter === filters[0]) return 0;

      var preferredIngredients = (filter.dataset.ingredientOrder || '').split(',').map(function(title) {
        return title.trim();
      }).filter(Boolean);
      var preferredTitles = new Set(preferredIngredients);

      return cards.filter(function(card) {
        return preferredTitles.has(card.dataset.ingredientTitle || '');
      }).length;
    }

    function getActiveFilter() {
      return filters.find(function(filter) {
        return filter.getAttribute('aria-selected') === 'true' || filter.classList.contains('active');
      }) || filters[0];
    }

    function getActiveFilterTitle() {
      var activeFilter = getActiveFilter();

      return activeFilter ? activeFilter.dataset.ingredientFilter : (filters[0] && filters[0].dataset.ingredientFilter);
    }

    function updateFilterRailEndState() {
      if (!filterRail) return;

      var canScroll = filterRail.scrollWidth > filterRail.clientWidth + 1;
      var hasEndBleed = filterRail.classList.contains('is-at-scroll-end');
      var distanceFromEnd = filterRail.scrollWidth - filterRail.clientWidth - filterRail.scrollLeft;

      if (!canScroll || filterRail.scrollLeft <= 0) {
        filterRail.classList.remove('is-at-scroll-end');
        return;
      }

      if (!hasEndBleed && distanceFromEnd <= 1) {
        filterRail.classList.add('is-at-scroll-end');
        return;
      }

      if (hasEndBleed && distanceFromEnd > 2) {
        var previousLeft = filterRail.getBoundingClientRect().left;
        var previousScrollLeft = filterRail.scrollLeft;

        filterRail.classList.remove('is-at-scroll-end');
        filterRail.scrollLeft = previousScrollLeft + filterRail.getBoundingClientRect().left - previousLeft;
      }
    }

    if (filterRail) {
      var filterRailFrame = null;
      var filterRailIsPositioning = false;
      var filterRailPositionTimer = null;
      filterRail.addEventListener('scroll', function() {
        if (filterRailIsPositioning) return;
        if (filterRailFrame) window.cancelAnimationFrame(filterRailFrame);
        filterRailFrame = window.requestAnimationFrame(function() {
          filterRailFrame = null;
          updateFilterRailEndState();
        });
      }, { passive: true });
    }

    function keepFilterFullyVisible(filter) {
      var rail = filter && filter.closest('.iit-tabs-title-container');
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      var isLastFilter = filter === filters[filters.length - 1];
      var exitedEndState = rail.classList.contains('is-at-scroll-end') && !isLastFilter;

      if (exitedEndState) {
        filterRailIsPositioning = true;
        window.clearTimeout(filterRailPositionTimer);
        rail.classList.add('is-reanchoring');
        rail.classList.remove('is-at-scroll-end');
      }

      window.requestAnimationFrame(function() {
        var railRect = rail.getBoundingClientRect();
        var filterRect = filter.getBoundingClientRect();
        var edgeGap = 8;
        var maximumScrollLeft = Math.max(0, rail.scrollWidth - rail.clientWidth);
        var targetScrollLeft = null;
        var getLeftAnchor = function(candidate) {
          return rail.scrollLeft + candidate.getBoundingClientRect().left - railRect.left;
        };

        if (exitedEndState) {
          targetScrollLeft = Math.min(getLeftAnchor(filter), maximumScrollLeft);
        } else if (filterRect.left < railRect.left) {
          targetScrollLeft = Math.min(getLeftAnchor(filter), maximumScrollLeft);
        } else if (filterRect.right > railRect.right - edgeGap) {
          var minimumScrollLeft = rail.scrollLeft + filterRect.right - railRect.right + edgeGap;
          var nextLeftAnchor = filters.find(function(candidate) {
            return getLeftAnchor(candidate) >= minimumScrollLeft - 1;
          });

          targetScrollLeft = Math.min(
            nextLeftAnchor ? getLeftAnchor(nextLeftAnchor) : maximumScrollLeft,
            maximumScrollLeft
          );
        }

        if (targetScrollLeft !== null && Math.abs(rail.scrollLeft - targetScrollLeft) > 1) {
          rail.scrollTo({
            left: targetScrollLeft,
            behavior: reduceMotion || exitedEndState ? 'auto' : 'smooth'
          });
        }

        if (exitedEndState) {
          filterRailPositionTimer = window.setTimeout(function() {
            rail.classList.remove('is-reanchoring');
            filterRailIsPositioning = false;
            updateFilterRailEndState();
          }, 100);
        }
      });
    }

    function filterIngredients(filterTitle, shouldAnimate) {
      var activeFilter = filters.find(function(filter) {
        return filter.dataset.ingredientFilter === filterTitle;
      });
      var preferredIngredients = activeFilter
        ? (activeFilter.dataset.ingredientOrder || '').split(',').map(function(title) { return title.trim(); }).filter(Boolean)
        : [];
      var ingredientRanks = new Map(preferredIngredients.map(function(title, index) {
        return [title, index];
      }));
      var isAllIngredients = activeFilter === filters[0];
      var firstPositions = new Map();
      var priorityCount = getPriorityCount(activeFilter);
      var visibleLimit = getVisibleLimit(priorityCount);
      var previewConfiguration = getPreviewConfiguration();
      var previewFadeCount = !expanded && visibleLimit < cards.length
        ? Math.min(previewConfiguration.columnCount, visibleLimit)
        : 0;

      if (shouldAnimate && !reduceMotion) {
        cards.forEach(function(card) {
          if (!card.hidden) firstPositions.set(card, card.getBoundingClientRect());
          if (typeof card.getAnimations === 'function') {
            card.getAnimations().forEach(function(animation) { animation.cancel(); });
          }
        });
      }

      filters.forEach(function(filter) {
        var isActive = filter.dataset.ingredientFilter === filterTitle;
        filter.classList.toggle('active', isActive);
        filter.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      var reorderedCards = cards.slice().sort(function(cardA, cardB) {
        var titleA = cardA.dataset.ingredientTitle || '';
        var titleB = cardB.dataset.ingredientTitle || '';
        var rankA = ingredientRanks.has(titleA) ? ingredientRanks.get(titleA) : Number.MAX_SAFE_INTEGER;
        var rankB = ingredientRanks.has(titleB) ? ingredientRanks.get(titleB) : Number.MAX_SAFE_INTEGER;

        if (rankA !== rankB) return rankA - rankB;
        return Number(cardA.dataset.originalIndex) - Number(cardB.dataset.originalIndex);
      });

      reorderedCards.forEach(function(card, index) {
        var isPriority = isAllIngredients || ingredientRanks.has(card.dataset.ingredientTitle || '');

        ingredientGrid && ingredientGrid.appendChild(card);
        card.hidden = index >= visibleLimit;
        card.classList.add('active');
        card.classList.toggle('is-priority', !isAllIngredients && isPriority);
        card.classList.toggle('is-deprioritized', !isAllIngredients && !isPriority);
        card.classList.toggle('is-preview-fade', previewFadeCount > 0 && index >= visibleLimit - previewFadeCount && index < visibleLimit);
      });
      if (ingredientGrid && supplementFactsCard) {
        ingredientGrid.appendChild(supplementFactsCard);
        supplementFactsCard.hidden = visibleLimit < cards.length;
      }

      lastVisibleLimit = visibleLimit;

      if (expandButton) {
        expandButton.hidden = expanded || visibleLimit >= cards.length;
        expandButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      if (shouldAnimate && !reduceMotion) {
        reorderedCards.forEach(function(card) {
          var firstPosition = firstPositions.get(card);

          if (card.hidden) return;

          if (!firstPosition && typeof card.animate === 'function') {
            var targetOpacity = card.classList.contains('is-deprioritized') ? 0.38 : 1;
            card.animate(
              [
                { opacity: 0, transform: 'translateY(12px)' },
                { opacity: targetOpacity, transform: 'translateY(0)' }
              ],
              { duration: 360, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
            );
            return;
          }

          var lastPosition = card.getBoundingClientRect();
          var deltaX = firstPosition.left - lastPosition.left;
          var deltaY = firstPosition.top - lastPosition.top;

          if ((!deltaX && !deltaY) || typeof card.animate !== 'function') return;

          card.style.willChange = 'transform';
          var animation = card.animate(
            [
              { transform: 'translate(' + deltaX + 'px, ' + deltaY + 'px)' },
              { transform: 'translate(0, 0)' }
            ],
            { duration: 440, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
          animation.addEventListener('finish', function() {
            card.style.willChange = '';
          }, { once: true });
        });
      }

      if (ingredientStatus) {
        var visibleCount = reorderedCards.filter(function(card) { return !card.hidden; }).length;
        var visibilityMessage = visibleCount < cards.length
          ? ' Showing ' + visibleCount + ' of ' + cards.length + ' active ingredients.'
          : ' Showing all ' + cards.length + ' active ingredients.';

        ingredientStatus.textContent = isAllIngredients
          ? visibilityMessage.trim()
          : preferredIngredients.length + ' ingredients directly linked to ' + filterTitle + ' moved to the top.' + visibilityMessage;
      }
    }

    function updateStickyShop() {
      if (!stickyShop) return;

      var rect = container.getBoundingClientRect();
      var modalIsOpen = document.body.classList.contains('ingredient-modal-open') || document.body.classList.contains('overflow-hidden');
      var shouldShow = rect.top < window.innerHeight * 0.6 && rect.bottom > 120 && !modalIsOpen;
      stickyShop.classList.toggle('is-visible', shouldShow);
      stickyShop.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      stickyShop.toggleAttribute('inert', !shouldShow);
    }

    function closeIngredientDialog() {
      if (!dialog || dialog.hidden) return;

      dialog.classList.remove('open');
      dialog.hidden = true;
      dialog.setAttribute('aria-hidden', 'true');
      dialog.setAttribute('inert', '');
      document.body.classList.remove('ingredient-modal-open');
      lastTrigger && lastTrigger.setAttribute('aria-expanded', 'false');
      updateStickyShop();
      lastTrigger && lastTrigger.focus({ preventScroll: true });
    }

    function openIngredientDialog(cardButton) {
      var template = document.getElementById(cardButton.dataset.templateId);
      if (!template || !dialog || !dialogContent) return;

      lastTrigger = cardButton;
      lastTrigger.setAttribute('aria-expanded', 'true');
      dialogContent.replaceChildren(template.content.cloneNode(true));
      dialogContent.querySelectorAll('a[target="_blank"]').forEach(function(link) {
        link.setAttribute('rel', 'noopener noreferrer');
      });
      dialog.hidden = false;
      dialog.setAttribute('aria-hidden', 'false');
      dialog.removeAttribute('inert');
      dialog.classList.add('open');
      document.body.classList.add('ingredient-modal-open');
      closeButton && closeButton.focus({ preventScroll: true });
      updateStickyShop();
    }

    filters.forEach(function(filter) {
      filter.addEventListener('click', function() {
        filterIngredients(filter.dataset.ingredientFilter, true);
        keepFilterFullyVisible(filter);
        updateStickyShop();
      });
    });

    if (expandButton) {
      expandButton.hidden = expanded || cards.length <= getVisibleLimit(getPriorityCount(getActiveFilter()));
      expandButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      expandButton.addEventListener('click', function() {
        expanded = true;
        container.dataset.ingredientExpanded = 'true';
        expandButton.setAttribute('aria-expanded', 'true');
        expandButton.hidden = true;
        filterIngredients(getActiveFilterTitle(), true);
      });
    }

    cards.forEach(function(card) {
      var button = card.querySelector('[data-ingredient-card]');
      button && button.addEventListener('click', function() {
        openIngredientDialog(button);
      });
    });

    closeButton && closeButton.addEventListener('click', closeIngredientDialog);
    dialog && dialog.addEventListener('click', function(event) {
      if (event.target === dialog) closeIngredientDialog();
    });
    document.addEventListener('keydown', function(event) {
      if (!dialog || dialog.hidden) return;
      if (event.key === 'Escape') {
        closeIngredientDialog();
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      var firstFocusable = focusable[0];
      var lastFocusable = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
    window.addEventListener('scroll', updateStickyShop, { passive: true });
    window.addEventListener('resize', function() {
      var nextVisibleLimit = getVisibleLimit(getPriorityCount(getActiveFilter()));
      if (!expanded && nextVisibleLimit !== lastVisibleLimit) {
        filterIngredients(getActiveFilterTitle(), false);
      }
      updateStickyShop();
      updateFilterRailEndState();
    });

    var configuredDefaultFilter = container.dataset.ingredientDefaultFilter;
    var initialFilter = filters.find(function(filter) {
      return filter.dataset.ingredientFilter === configuredDefaultFilter;
    }) || filters[0];

    if (initialFilter) {
      filterIngredients(initialFilter.dataset.ingredientFilter, false);
      keepFilterFullyVisible(initialFilter);
    }
    updateFilterRailEndState();
    updateStickyShop();
  }

  window.BuddyIngredientBrowser = window.BuddyIngredientBrowser || {};
  window.BuddyIngredientBrowser.initialize = initializeIngredientBrowser;
  document.querySelectorAll('[data-ingredients-browser]').forEach(initializeIngredientBrowser);

//   setTimeout(function(){
//     $('.variant-input-wrapper [type="radio"]:checked').trigger('change');
//   },2000);



// var ulElements = document.querySelectorAll('.shopify_subscriptions_app_block_label_children');

// ulElements.forEach(function(ul) {
//     var liElements = ul.querySelectorAll('li');
//     liElements.forEach(function(li, index) {
//         var label = li.querySelector('label');
//         if (label) {
//             var input = label.querySelector('input');
//             if (input) {
                
//                 var variantPrice = parseFloat(input.getAttribute('data-variant-price').replace('$', '').replace(' USD', ''));
//                 var compareAtPrice = parseFloat(input.getAttribute('data-variant-compare-at-price').replace('$', '').replace(' USD', ''));
//                 var discountPercentage = ((compareAtPrice - variantPrice) / compareAtPrice) * 100;

               
//                 if (index === liElements.length - 1) { 
//                     var discountSpan = document.createElement('span');
//                     discountSpan.textContent = `(save ${Math.round(discountPercentage)}%)`;
//                     discountSpan.style.display = 'block'; 
//                   discountSpan.style.marginLeft  = 'auto';
//                   discountSpan.style.fontWeight = '200'; 
//                     ul.appendChild(discountSpan); 
//                 }

               
//                 var newText = document.createTextNode(' Subscribe and Save');

                
//                 while (label.firstChild) {
//                     label.removeChild(label.firstChild);
//                 }

               
//                 label.appendChild(input);
//                 label.appendChild(newText);

              
//                 if (index === 0) { 
//                     input.checked = true;
//                 }
//             }
//         }
//     });
  
// });


// var hiddenElements = document.querySelectorAll('.shopify_subscriptions_app_block--hidden');


// hiddenElements.forEach(function(element) {
//     element.classList.remove('shopify_subscriptions_app_block--hidden');
// });
  

// var targetUls = document.querySelectorAll(".shopify_subscriptions_app_block_label_children");


// targetUls.forEach(function(targetUl) {
    
//     var targetLi = targetUl.querySelector("li");
    

//     var priceDiv = targetUl.closest('.shopify_subscriptions_app_block_label').querySelector(".shopify_subscriptions_in_widget_price.allocation_price");

   
//     if (targetLi && priceDiv) {
      
//         targetLi.insertAdjacentElement('afterend', priceDiv);
//     }
// });


// document.querySelectorAll('.shopify_subscriptions_app_block_label label').forEach(function(label) {
   
//     if (!label.closest('.shopify_subscriptions_purchase_option_wrapper') ||
//         label.closest('.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper')) {
        
//         label.style.fontWeight = 'bold';
//         label.style.textTransform = 'capitalize';
//     }
// });

});

// $(function(){
//     $('.shopify_subscriptions_app_block').addClass('shopify_subscriptions_app_block--hidden');
//      var variant_id = $('.variant-input-wrapper [type="radio"]:checked').next('[data-variant-id]').data('variant-id');
//     $('.shopify_subscriptions_app_block[data-variant-id="'+variant_id+'"]').removeClass('shopify_subscriptions_app_block--hidden');
//     $('[name="id"]').val(variant_id);
// });

// document.addEventListener('DOMContentLoaded', function() {
//     let sellingPlanRadios = document.querySelectorAll("input[type='radio'][data-radio-type='selling_plan']");
//     sellingPlanRadios.forEach(radio => {
        
//         radio.closest('.shopify_subscriptions_app_block_label').style.backgroundColor = '#f0f0e2';
//         radio.closest('.shopify_subscriptions_app_block_label').style.setProperty('border-color', '#1D1D1B', 'important');
//     });

    
//     let oneTimePurchaseRadios = document.querySelectorAll("input[type='radio'][data-radio-type='one_time_purchase']");
//     oneTimePurchaseRadios.forEach(function(radio, index) {
//         radio.addEventListener('change', function() {
            
//             this.closest('.shopify_subscriptions_purchase_option_wrapper').style.backgroundColor = '#f0f0e2';
//             this.closest('.shopify_subscriptions_purchase_option_wrapper').style.setProperty('border-color', '#1D1D1B', 'important');

            
//             if (sellingPlanRadios[index]) {
//                 sellingPlanRadios[index].closest('.shopify_subscriptions_app_block_label').style.backgroundColor = '';
//                 sellingPlanRadios[index].closest('.shopify_subscriptions_app_block_label').style.setProperty('border-color', '');
//             }
//         });
//     });

    
//     sellingPlanRadios.forEach(function(radio, index) {
//         radio.addEventListener('change', function() {
            
//             this.closest('.shopify_subscriptions_app_block_label').style.backgroundColor = '#f0f0e2';
//             this.closest('.shopify_subscriptions_app_block_label').style.setProperty('border-color', '#1D1D1B', 'important');
            
           
//             if (oneTimePurchaseRadios[index]) {
//                 oneTimePurchaseRadios[index].closest('.shopify_subscriptions_purchase_option_wrapper').style.backgroundColor = '';
//                 oneTimePurchaseRadios[index].closest('.shopify_subscriptions_purchase_option_wrapper').style.setProperty('border-color', '');
//             }
//         });
//     });
// });



// document.addEventListener("DOMContentLoaded", function() {
 

// function makeParentClickable(containerSelector, parentSelector, radioSelector) {
  
//   const container = document.querySelector(containerSelector);
  
//   if (!container) {
//     console.warn('Container for makeParentClickable not found:', containerSelector);
//     return;
//   }

  
//   container.addEventListener('click', function(e) {
    
//     const parent = e.target.closest(parentSelector);

   
//     if (parent && e.target.type !== 'radio') {
     
//       const radioButton = parent.querySelector(radioSelector);
     
//       if (radioButton && !radioButton.checked) {
      
//         e.preventDefault();
        
//         radioButton.click();
//       }
//     }
//   });
// }


// makeParentClickable('body', '.shopify_subscriptions_app_block_label', 'input[type="radio"]');

 

//   const fieldsets = Array.from(document.querySelectorAll('fieldset'));
//   const targetFieldset = fieldsets.find(fieldset => {
    
//     return fieldset.querySelectorAll('input[type="radio"]').length > 0 && 
//            fieldset.querySelector('legend').textContent.toLowerCase().includes("dog's size");
//   });

//   if (!targetFieldset) return; 

//   const labels = targetFieldset.querySelectorAll('label');

//   labels.forEach(label => {
    
//     let contents = label.innerHTML.split('<br>');
//     let size = contents[0].trim();
//     let weight = contents[1].replace('&lt;', '<').replace('&gt;', '>').trim();

   
//     const boldSize = document.createElement('b');
//     boldSize.textContent = size;

//     const spanWeight = document.createElement('span');
//     spanWeight.innerHTML = weight; 

//     label.innerHTML = '';
//     label.appendChild(boldSize);
//     label.appendChild(spanWeight);
//   });

  
// });

// function getSelectedDogSize() {
//     var sampleRadioButton = document.querySelector('.variant-input-wrapper input[type="radio"]');
//     var fieldName = sampleRadioButton ? sampleRadioButton.name : null;

//     if (fieldName) {
//         var querySelectorString = `.variant-input-wrapper input[name="${fieldName}"]:checked`;
//         var selectedSizeRaw = document.querySelector(querySelectorString).getAttribute('data-option-value');

//         console.log(selectedSizeRaw); 

//         var selectedSize = selectedSizeRaw.split(" ")[0];
//         console.log("Selected dog size:", selectedSize);

//         var daySupply = selectedSize === 'Small' ? '60-day supply' : '30-day supply';

//         document.querySelector('.variant-selected-supply').textContent = daySupply;
//     } else {
//         console.error('Field name not found.');
//     }
// }

// getSelectedDogSize();

// var fieldName = document.querySelector('.variant-input-wrapper input[type="radio"]')?.name;
// if (fieldName) {
//     document.querySelectorAll(`.variant-input-wrapper input[name="${fieldName}"]`).forEach(function(input) {
//         input.addEventListener('change', getSelectedDogSize);
//     });
// } else {
//     console.error('Unable to add event listeners: Field name not found.');
// }
//  document.querySelectorAll('.shopify_subscriptions_in_widget_price, label').forEach(function(node) {
//     node.innerHTML = node.innerHTML.replace(/\$([0-9,.]+) USD/g, '$$$1');
// });

// 6-month selections no longer hide one-time purchase options.
